module.exports = __webpack_public_path__ + "img/Verbandführer_II.fe3c872c.svg";